import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M7 4a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v.5a3 3 0 0 1 3 3V9h1a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3v-8a3 3 0 0 1 3-3h1V7.5a3 3 0 0 1 3-3V4Zm2 .5h6V4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v.5ZM6 9h12V7.5a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1V9Zm-3 2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1H3Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
